var _excluded = ["classes", "children", "elevate", "fill", "outlined", "overflow", "skeleton", "rounded"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { StyledPaper } from './Paper.styled';
function Paper(_ref) {
  var classes = _ref.classes,
    children = _ref.children,
    elevate = _ref.elevate,
    fill = _ref.fill,
    outlined = _ref.outlined,
    overflow = _ref.overflow,
    skeleton = _ref.skeleton,
    rounded = _ref.rounded,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledPaper, _extends({
    className: classes,
    elevate: +elevate,
    fill: +fill,
    outlined: +outlined,
    skeleton: +skeleton,
    rounded: +rounded
  }, rest), children);
}
Paper.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The content of the component. React component, node, text etc.
   */
  children: PropTypes.node.isRequired,
  /**
   * Extend the classes to creates extra styles of the component.
   */
  classes: PropTypes.string,
  /**
   * Adds the box shadow
   */
  elevate: PropTypes.bool,
  /**
   * If `true`, adaptes parent width and height
   */
  fill: PropTypes.bool,
  /**
   * Makes background color transparent
   */
  outlined: PropTypes.bool,
  /**
   * Allows content overflows an element's box
   */
  overflow: PropTypes.bool,
  /**
   * Shows the element in loading state
   */
  skeleton: PropTypes.bool,
  /**
   * Makes the edges rounded
   */
  rounded: PropTypes.bool
} : {};
Paper.defaultProps = {
  classes: '',
  elevate: true,
  fill: false,
  outlined: false,
  overflow: false,
  skeleton: false,
  rounded: true
};
export default Paper;